import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import LeadService from "services/Provider/LeadService"

function ModalForm({ modal, toggle, id, type, setShouldUpdateDate }) {
    const leadService = new LeadService()
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        description: "",
        title: "",
        activity: ""
    })

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleValidSubmit = (_, values) => {
        const data = {
            ...formData,
            lead_id: id,
            type: "Lead"
        }
        setLoading(true)
        leadService.addFeedback(data).then(res => {
            if (res && res.status === SuccessCreated) {
                if (type === "details") {
                    setShouldUpdateDate(c =>c+1)
                }
                toast.success("Feedback successfully added")
                toggle()

            }else {
                setLoading(false)
              }
        })
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>

                <ModalBody>
                    <Row>
                        <Row className="my-0 p-1 d-flex justify-content-between">
                            <Col><span className="font-size-15 fw-bold">Add Feedback</span></Col>
                            {/* <Col><span className="font-size-15 fw-bold d-flex flex-md-row-reverse btn-hover" onClick={toggle} >X</span></Col> */}

                        </Row>
                        <Row> <span className="font-size-13 text-muted px-1">Add title and description to can add feedback</span>
                        </Row>
                    </Row>
                    <hr />
                    <Row>
                        <Col md={12}   >
                            <AvField
                                className="mb-3"
                                name={"title"}
                                label={`Title`}
                                value={formData.title}
                                onChange={e => handleFieldChange(e)}
                                bsSize="lg"
                                required
                                type="text"
                                placeholder={"Type Title"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}   >
                            <AvField
                                className="mb-3"
                                name={"description"}
                                label={`Description`}
                                value={formData.description}
                                onChange={e => handleFieldChange(e)}
                                bsSize="lg"
                                required
                                type="textarea"
                                placeholder={"Type description"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="m-0">
                            <CardText tag='h6' className='fw-bold'>
                                Activity
                          </CardText>
                            <AvRadioGroup className="mt-2" inline name="activity" required value={formData.activity} onChange={handleFieldChange} >
                                <AvRadio label="Call" value="Call" />
                                <AvRadio label="Meeting" value="Meeting" />
                                <AvRadio label="Email" value="Email" />
                                <AvRadio label="Visit" value="Visit" />
                            </AvRadioGroup>
                        </Col>
                    </Row>
                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='submit'
                        disabled={loading ? true :false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </AvForm>
        </Modal>

    )
}

export default ModalForm
